export const Links = {
  Landing: "/",

  Dashboard: "/dashboard",
  Team: "/team",
  Users: "/users",
  UserDetail: "/userDetail",

  ReportedUsers: "/reportedUsers",
  Feedback: "/feedback",
  HearAboutUs: "/hearAboutUs",
  Messaging: "/messaging",
  StartChat: "/startChat",
  Retention: "/retention",

  // Campaigns
  Campaigns: "/campaigns",
  CreateCampaign: "/campaigns/create",
  CampaignDetail: "/campaigns/detail",
  GenerateQR: "/campaigns/qr",
};
